import styled from '@emotion/styled';
import { useScreenBreakpoint } from 'consts/breakpoints';
import React from 'react';
import { connect } from 'react-redux';
import { PromotionPlanType, UserPromotionPlan } from 'store/sagas/apiService/types';
import StarIcon from 'assets/svg/promotion-stars.svg';
import { SmallText, Text } from 'ds/components/typography';
import { State } from 'store/state';
import { currentPromotionPlanDomainDataSelector } from 'store/state/app/private-user-monetization/selectors';
import { useLocale } from 'locale';
import { useRoute } from 'config/routes';

const Wrapper = styled.div<{ isMobile: boolean; }>(({ theme, isMobile }) => ({
  borderRadius: isMobile ? 'none' : theme.borderRadius.small,
  background: 'linear-gradient(248.28deg, #95E3C4 0.23%, #8EDBDD 98.9%)',
  padding: `${theme.spacing(1.25)} ${theme.spacing(2)}`,
  display: 'flex',
  gap: theme.spacing(1),
  position: isMobile ? 'static' : 'absolute',
  top: isMobile ? undefined : -60,
  left: isMobile ? undefined : 0,
}));

const TextWrapper = styled.div<{ isMobile: boolean; }>(({ theme, isMobile }) => ({
  display: 'flex',
  flexDirection: isMobile ? 'column' : 'row',
  alignItems: isMobile ? 'flex-start' : 'center',
  gap: isMobile ? 0 : theme.spacing(1),
}));

const MainText = styled(Text)(({ theme }) => ({
  color: theme.colors.brand.main,
}));

const Subtitle = styled(SmallText)(({ theme }) => ({
  color: theme.colors.brand.main,
}));

const PromotionInfoBanner: React.FC<{ currentPlan: UserPromotionPlan; }> = ({ currentPlan }) => {
  const screen = useScreenBreakpoint();
  const { t } = useLocale();
  const { route: { params: { id } } } = useRoute();
  const isMobile = screen < 3;

  const lastAutomaticPromotion = currentPlan && currentPlan.latestAutomaticPromotions && currentPlan.latestAutomaticPromotions.find(el => el.bulletinId === id);
  const lastManualPromotion = currentPlan && currentPlan.latestManualPromotions && currentPlan.latestManualPromotions.find(el => el.bulletinId === id);
  const manualPromotion = lastManualPromotion && (new Date(lastManualPromotion.promotedAt));
  const autoPromotion = lastAutomaticPromotion && (new Date(lastAutomaticPromotion.promotedAt));

  if (
    !autoPromotion
    || (manualPromotion && autoPromotion && (autoPromotion < manualPromotion))
    || currentPlan.promotionPlan.type === PromotionPlanType.BASIC
  ) return null;

  const diffMs = (new Date()).getTime() - autoPromotion.getTime();
  const diffMinutes = Math.floor(diffMs / (1000 * 60));

  return (
    <Wrapper isMobile={isMobile}>
      <StarIcon width={24} height={24} />
      <TextWrapper isMobile={isMobile}>
        <MainText weight="bold">{t('listingPage.promotionPlanBanner.title', { diffMinutes: diffMinutes || 1 })}</MainText>
        <Subtitle>{t('listingPage.promotionPlanBanner.subtitle')}</Subtitle>
      </TextWrapper>
    </Wrapper>
  );
};

const mapStateToProps = (state: State) => ({
  currentPlan: currentPromotionPlanDomainDataSelector(state),
});

export default connect(mapStateToProps)(PromotionInfoBanner);
